import { NavbarVariantEnum } from 'src/types';
import styled from 'styled-components';

// New layout containers that match the Internal Routing pattern
export const PublicRoutingContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100vh;
  width: 100vw;
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-weight: 100;

  * {
    box-sizing: border-box;
  }
`;

export const PublicRoutingBody = styled.div<{ variant?: NavbarVariantEnum }>`
  height: 100%;
  width: 100%;
  background-color: ${(props) => props.theme.newPalette.neutral.N0};
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: ${(props) =>
    props.variant === NavbarVariantEnum.PUBLIC ? 'center' : 'flex-start'};
`;

export const ContentContainer = styled.div<{ variant?: NavbarVariantEnum }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: ${(props) =>
    props.variant === NavbarVariantEnum.PUBLIC ? '90%' : '100%'};
`;

export const ChildrenWrapper = styled.div<{
  vaultIDShowing: boolean;
  isMessages: boolean;
  greyBackground?: boolean;
  shadowBackground?: boolean;
  variant?: NavbarVariantEnum;
}>`
  height: ${(props) =>
    props.vaultIDShowing
      ? 'calc(100% - 120px)'
      : props.isMessages
        ? 'calc(100% - 60px)'
        : '100%'};
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  ${(props) =>
    props.shadowBackground &&
    'box-shadow: 0px 0px 11px -1px rgba(150, 150, 150, 0.3);'}
  ${(props) => props.greyBackground && 'background-color: rgba(0,0,0,0.02);'}
  ${(props) =>
    props.variant === NavbarVariantEnum.PUBLIC && 'align-items: center;'}
`;

export const FooterWrapper = styled.div`
  padding: 20px;
  display: flex;
  justify-content: center;
  background-color: ${(props) => props.theme.newPalette.neutral.N0};
`;
